import React from "react";
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";
import { Col, Row } from "reactstrap";

type TProps = {
  title: string;
  pageTitle: string;
  component?: React.ReactNode;
  link?: string;
};

export const BreadCrumb: React.FC<TProps> = ({
  title,
  pageTitle,
  component,
  link,
}) => {
  const { t } = useTranslation();
  return (
    <React.Fragment>
      <Row>
        <Col xs={12}>
          <div className="page-title-box d-sm-flex align-items-center justify-content-between">
            <h4 className="mb-sm-0">{title}</h4>
            <div className="page-title-right">
              <ol className="breadcrumb m-0">
                {pageTitle && (
                  <li
                    className={`breadcrumb-item align-items-center justify-content-center d-flex ${
                      link ? "" : "active"
                    }`}
                  >
                    {link ? (
                      <Link to={link}>{t(pageTitle)}</Link>
                    ) : (
                      t(pageTitle)
                    )}
                  </li>
                )}
                {component ? (
                  component
                ) : (
                  <li className="breadcrumb-item active">{t(title)}</li>
                )}
              </ol>
            </div>
          </div>
        </Col>
      </Row>
    </React.Fragment>
  );
};

export interface BreadCrumbItem {
  title: string;
  link?: string;
}
